import _ from 'lodash'
import utils from '../utils'

export default {
    methods: {
        translateRequestCompanyBrandProductsToReceipt(requestCompanyBrandProducts) {
            // produto  quantidade  valor unitário  total
            const products = []
            requestCompanyBrandProducts.forEach(requestCompanyBrandProduct => {
                const product = _.get(requestCompanyBrandProduct.companyBrandProduct, 'brandProduct')

                const companyBrandProduct = _.get(requestCompanyBrandProduct,'companyBrandProduct')

                let brandName = "", brandProductName = ""
                if(!!utils.get(companyBrandProduct,'brandProduct.brand.name')){
                    brandName += utils.get(companyBrandProduct,'brandProduct.brand.name')
                }
                if(!!utils.get(companyBrandProduct,'brandProduct.name')){
                    brandProductName += utils.get(companyBrandProduct,'brandProduct.name')
                }
                const productName = companyBrandProduct.brandProduct.product.name + (!!brandName ? ' - ' + brandName : '') + (!!brandProductName ? ' - ' + brandProductName : '')

                if(product) {
                    const quantity = requestCompanyBrandProduct.quantity
                    const unitPrice = ((requestCompanyBrandProduct.unitPrice - requestCompanyBrandProduct.unitDiscount) + this._sumRequestExtras(requestCompanyBrandProduct.requestCompanyBrandProductExtras)).toFixed(2)
                    const totalPrice = (parseFloat(unitPrice) * quantity).toFixed(2)
                    products.push(`${this.addSpaces(productName, 19, false)} ${this.addSpaces(quantity + '', 4)} ${this.addSpaces(unitPrice.replace('.', ','), 7)} ${this.addSpaces(totalPrice.replace('.', ','), 7)}`)
                    if(requestCompanyBrandProduct.requestCompanyBrandProductExtras) {
                        requestCompanyBrandProduct.requestCompanyBrandProductExtras.forEach(requestCompanyBrandProductExtra => {
                            if(!requestCompanyBrandProductExtra.requestExtra || !requestCompanyBrandProductExtra.requestExtra.requestExtraChoices) return
                            requestCompanyBrandProductExtra.requestExtra.requestExtraChoices.forEach(requestExtraChoice => {
                                products.push(this.addSpaces(`- ${requestExtraChoice.title} ${requestExtraChoice.quantity ? 'x' + requestExtraChoice.quantity : ''} ${requestExtraChoice.unitPrice ? utils.formatMoney((requestExtraChoice.quantity * requestExtraChoice.unitPrice), 2, '', '.', ',') : ''}`, 40, false))
                            })
                        })
                    }

                }
            })
            return products
        },

        _sumRequestExtras(requestCompanyBrandProductExtras) {
            return _.sumBy(requestCompanyBrandProductExtras, requestCompanyBrandProductExtra => {
                if(!requestCompanyBrandProductExtra.requestExtra) return 0
                return _.sumBy(requestCompanyBrandProductExtra.requestExtra.requestExtraChoices, requestExtraChoice => {
                    if(!requestExtraChoice.unitPrice) return 0
                    return parseFloat(requestExtraChoice.unitPrice) * requestExtraChoice.quantity
                })
            })
        },

        _getTotalRequestCompanyBrandProducts(requestCompanyBrandProducts) {
            return _.sumBy(requestCompanyBrandProducts, requestCompanyBrandProduct => {
                return ((requestCompanyBrandProduct.unitPrice - requestCompanyBrandProduct.unitDiscount) + this.sumRequestExtras(requestCompanyBrandProduct.requestCompanyBrandProductExtras)) * requestCompanyBrandProduct.quantity 
            })
        },

        translateRequestOrderPaymentsToReceipt(requestOrderPayments) {
            const paymentMethods = []
            requestOrderPayments.forEach(requestOrderPayment => {
                const paymentMethod = this.VXORM.PaymentMethod.find(requestOrderPayment.paymentMethodId)
                if(paymentMethod) {
                    paymentMethods.push(`${this.addSpaces(paymentMethod.name.toUpperCase(), 40, false)}`)
                }
            })
            return paymentMethods
        },

        translateRequestAddressToReceipt(requestAddress) {
            const addressLines = []
            if(!requestAddress) return addressLines

            const address = {
                name: requestAddress && requestAddress.name ? `END: ${requestAddress.name}` : '',
                number: requestAddress.number ? `NUM: ${requestAddress.number}` : '',
                neighborhood: requestAddress && requestAddress.neighborhood ? `BAIRRO: ${requestAddress.neighborhood}` : '',
                complement: requestAddress.complement ? `COMP: ${requestAddress.complement}` : '',
                referencePoint: requestAddress.referencePoint ? `REF: ${requestAddress.referencePoint}` : '',
                city: requestAddress.address && requestAddress.city ? `CID: ${requestAddress.city} - ${requestAddress.state}` : '',
                postalCode: requestAddress && requestAddress.cep ? `CEP: ${requestAddress.cep}` : ''
            }
            for(const key in address) {
                const _address = address[key] 
                if(_address) addressLines.push(this.addSpaces(_address, 40, false))
            }
            return addressLines
        },

        addSpaces(text, maxLength, atTheBeginning = true) {
            console.log("Textt", text)
            if(!text) text = ""
            if(text.length >= maxLength) 
                return text.substr(0, maxLength)
                
            const diff = maxLength - text.length

            let spaces = ''
            for(let i = 0; i < diff; i++) {
                spaces += ' '
            }
 
            return atTheBeginning ? spaces += text : text += spaces
        },

        centralizeText(text, columns = 40) {
            if(text === null) return ' '
            const _text = text

            let formattedText
            if(_text.length < columns) {
                let spaces = Math.floor((columns - _text.length) / 2)
                let space = ''
                for(let i = 0; i < spaces; i++) {
                    space += ' '
                } 
                formattedText = space += _text
            }
            else {
                formattedText = _text.substr(0, columns)
            }
            return formattedText
        },

        breakLine(text, columns = 40, linesLimit = 3) {
            const lines = []
            if(text.length > columns) {
                let textSubStr = text.substring(0, columns) 
                lines.push(textSubStr)
                
                let _columns = columns
                for(let i = 1; i < linesLimit; i++) {
                    lines.push(text.substring(_columns, columns * (i + 1)))
                    _columns = columns * (i + 1)
                }
            }
            else 
                lines.push(text)
            
           return lines
        },

        formatValues(request) {
            console.log(request)
            const skipLine = '-'.repeat(40)
            const lines = []
            const requestCode = this.centralizeText('PEDIDO: ' + request.code)
            const products = this.translateRequestCompanyBrandProductsToReceipt(request.requestCompanyBrandProducts)
            const subtotal = this._getTotalRequestCompanyBrandProducts(request.requestCompanyBrandProducts)
            const discount = 0
            const total = subtotal - discount
            const requestAddressLines = this.translateRequestAddressToReceipt(request.requestAddress)
            
            lines.push(skipLine)
            lines.push(requestCode)
            lines.push(skipLine)
            lines.push('')
            lines.push(this.centralizeText(request.requestCompany.name))
            if(request.requestCompany.legalDocument)
                lines.push(this.centralizeText(request.requestCompany.legalDocument))
            lines.push('')
            lines.push(skipLine)
            lines.push(this.centralizeText('ITENS DO PEDIDO'))
            lines.push(skipLine)
            lines.push('')
            lines.push(`${this.addSpaces('ITEM', 19, false)}${this.addSpaces('QNT', 5)}${this.addSpaces('V. UN', 8)}${this.addSpaces('TOTAL', 8)}`.toUpperCase())
            lines.push(...products)
            lines.push('')
            lines.push(this.addSpaces(`SUBTOTAL ${utils.formatMoney(subtotal, 2, '', '.', ',')}`, 40, true))
            lines.push(this.addSpaces(`DESCONTO ${utils.formatMoney(discount, 2, '', '.', ',')}`, 40, true))
            lines.push('')
            lines.push(this.addSpaces(`TAXA DE ENTREGA ${utils.formatMoney(request.deliveryTax, 2, 'R$', '.', ',')}`, 40, true))
            lines.push(this.addSpaces(`TOTAL ${utils.formatMoney(total, 2, 'R$', '.', ',')}`, 40, true))
            lines.push('')
            lines.push(skipLine)
            lines.push(this.centralizeText('FORMA DE PAGAMENTO'))
            lines.push(skipLine)
            lines.push('')
            lines.push(`${this.addSpaces(request.requestPayment.paymentMethod.name, 33, false)}${this.addSpaces(utils.formatMoney(total, 2, 'R$', '.', ','), 7)}`)
            if(!request.requestPayment.paymentMethod.onDelivery)
                lines.push('Não cobrar do cliente')
            lines.push('')
            lines.push(skipLine)
            lines.push(this.centralizeText('DADOS DO CLIENTE'))
            lines.push(skipLine)
            lines.push('')
            lines.push(this.addSpaces('NOME: ' + request.user.name))
            if(request.user.legalDocument)
                lines.push(this.centralizeText(request.user.legalDocument))
            lines.push('')
            requestAddressLines.forEach(requestAddressLine => {
                lines.push(requestAddressLine)
            })
            lines.push('')
            if(request.obs) {
                lines.push('OBSERVAÇÕES: ')
                this.breakLine(request.obs)
                    .forEach(obsLines => {
                        lines.push(obsLines)
                    })
            }

            return lines.join('\n')
        }
    }
}